export enum CfmTransferOrderPostingTypeModel {
  Recycled = "recycled",
}
